import React, { Fragment, useRef, useState } from 'react'

import { useSelector, shallowEqual } from 'react-redux'
import { useLocation, Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { useEventListener } from '../../_helpers'
// import {
//     PageBlock,
// } from '../'
import {
    // ArticleWrap,
    Container,
    // Row,
    Meta,
    // ContentWrap,
    // ArticleWrapColumn,
    // Block,
    // Title,
    devices,
    colors,
} from '../Common'

const ImageCard = ({ image }) => {
    const [spans, setSpans] = useState(0)
    const imageRef = useRef()

    const setSpan = () => {
        const height = imageRef.current.clientHeight
        const spans = Math.ceil(height / 10)
        setSpans(spans)
    }

    useEventListener('load', setSpan)

    return (
        <div style={{ gridRowEnd: `span ${spans}` }}>
            <img ref={imageRef} src={image.image} alt={image.alt_text} />
        </div>
    )
}


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    // const location = useLocation()
    const { gallery } = page

    if (notFound) return <Redirect to='/' />

    return (
        <Fragment>
            <Meta page={page} />
            <PageContainer>
                {gallery.length ?
                    <ImageList>
                        {gallery.map((image, i) => <ImageCard key={i} image={image} />)}
                    </ImageList>
                    : ''}
            </PageContainer>
        </Fragment>
    )
}

const PageContainer = styled(Container)`
    min-height: 100vh;
    background: ${colors.black};
`

const ImageList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-gap: 0 10px;
    grid-auto-rows: 10px;

    img {
        width: 250px;
        border: 1px solid white;
    }
`

export default PageView
